module.exports = __webpack_public_path__ + "img/tilly-mascot.a5198a47.png";